import axios from "axios";
import { jsonToFormData } from "../shared/helpers/mapEntityToFormDataPostulate";
import { defaultValue, ICandidate } from "../shared/model/candidate.model";
import { FAILURE, REQUEST, SUCCESS } from "./actionType.util";

// TYPES
export const ACTION_TYPES = {
  FETCH_CANDIDATE: "candidate/FETCH_CANDIDATE",
  CREATE_CANDIDATE: "candidate/CREATE_CANDIDATE",
  UPDATE_CANDIDATE: "candidate/UPDATE_CANDIDATE",
  RESET: "candidate/RESET",
};

const initialState = {
  loading: false,
  errorMessage: null,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type CandidateState = Readonly<typeof initialState>;

// RECUCER

export const candidateReducer = (
  state: CandidateState = initialState,
  action: any
) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CANDIDATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CANDIDATE):
    case REQUEST(ACTION_TYPES.UPDATE_CANDIDATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CANDIDATE):
    case FAILURE(ACTION_TYPES.CREATE_CANDIDATE):
    case FAILURE(ACTION_TYPES.UPDATE_CANDIDATE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };

    case SUCCESS(ACTION_TYPES.FETCH_CANDIDATE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CANDIDATE):
    case SUCCESS(ACTION_TYPES.UPDATE_CANDIDATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

// ACTIONS
const apiUrl = "/api/ksds/portal-external/postulate/candidate";
export const getEntity = (id: string) => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_CANDIDATE,
    payload: axios.get<ICandidate>(requestUrl),
  };
};

export const getCandidateWithCode = (candId: string, code: string) => {
  const requestUrl = `/api/ksds/portal-external/candidates/validate-code?id=${candId}&code=${code}`;
  return {
    type: ACTION_TYPES.FETCH_CANDIDATE,
    payload: axios.get(requestUrl),
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});

export const createEntity: any =
  (entity: ICandidate, id: number | string) => async (dispatch) => {
    const { formData, config } = jsonToFormData(entity);
    const requestUrl = `${apiUrl}/${id}`;

    const result = await dispatch({
      type: ACTION_TYPES.CREATE_CANDIDATE,
      payload: axios.post(requestUrl, formData, config),
    });
    return result;
  };
export const updateEntity: any =
  (entity: ICandidate, id: number | string) => async (dispatch) => {
    const { formData, config } = jsonToFormData(entity);
    const requestUrl = `${apiUrl}/update/${id}`;

    const result = await dispatch({
      type: ACTION_TYPES.UPDATE_CANDIDATE,
      payload: axios.put(requestUrl, formData, config),
    });
    return result;
  };
